import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import AmbassadorPage from "@/pages/AmbassadorPage";

const TOAST_OPTIONS = {
  style: {
    background: '#1A1A1A',
    border: '1px solid #FFD700',
    color: '#EDEDED',
  },
};

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ambassador" element={<AmbassadorPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}

export default App;
